<div class="stock-wrapper my-store">
  @if(showRealTimeBanner){
  <div class="stock-row banner">
    <span class="title">
      {{"Stock may not be updated in real time"|translate}}
    </span>
  </div>
  }

  @if (mainStock) {
  <div class="stock-row title"><span>{{"MAIN STOCK"|translate}}</span></div>
  <div class="stock-row free">
    <span class="title">{{"free"|translate}}</span>
    <span class="count">{{mainStock?.free}}</span>
  </div>
  <div class="stock-row">
    <span class="title">{{"reservation"|translate}}</span>
    <span class="count">{{mainStock?.reservation}}</span>
  </div>
  <div class="stock-row">
    <!--* Quando si passerà a stock S4 occorre rinominare il campo in "COSIGNMENT OUT" -->
    <!-- <span class="title">{{"consignment"|translate}}</span> -->
    <span class="title">{{"CONSIGNMENT"|translate}}</span>
    <span class="count">{{mainStock?.consignment}}</span>
  </div>
  @if(s4StockIsTrue){
  <div class="stock-row">
    <span class="title">{{"qualityInspection"|translate}}</span>
    <span class="count">{{mainStock?.qualityInspection}}</span>
  </div>
  @if(eCommerceReservation){
  <div class="stock-row">
    <span class="title">{{"eCommerceReservation"|translate}}</span>
    <button class="btn btn-link count"
      (click)="handleECommerceReservationClick()">{{eCommerceReservationTotal}}</button>
  </div>
  }
  }
  }

  <!--* Quando si passerà a stock S4 occorre rimuovere questo "if" -->
  @if (s4StockIsTrue) {
  <div class="stock-row title"><span>{{"CONSIGNMENT"|translate}}</span></div>
  <div class="stock-row"><span class="title">{{"CONSIGNMENT IN"|translate}}</span><span
      class="count">{{consignmentIn?.free}}</span></div>
  }

  <!--* Quando si passerà a stock S4 occorre rimuovere questo "if" -->
  @if(s4StockIsTrue){
  @if((showOther && this.authService.user?.isUserStore) || this.authService.user?.isNotUserStore){
  <div class="stock-accordion accordion-item">
    <button class="accordion-button collapsed stock-row" type="button" data-bs-toggle="collapse" aria-expanded="false"
      [attr.aria-controls]="'collapse-other'" appAccordion>
      {{'OTHER'|translate}}
    </button>
    <div [id]="'collapse-other'" class="accordion-collapse collapse">
      <div class="accordion-body">
        @if(mainStock){
        <div class="stock-row title"><span>{{"MAIN STOCK"|translate}}</span></div>
        <div class="stock-row"><span class="title">{{"toVendor"|translate}}</span><span
            class="count">{{mainStock?.toVendor}}</span></div>
        <div class="stock-row"><span class="title">{{"blocked"|translate}}</span><span
            class="count">{{mainStock?.blocked}}</span></div>
        }
        @if (omniChannel) {
        <div class="stock-row title"><span>{{"OMNICHANNEL"|translate}}</span></div>
        <div class="stock-row"><span class="title">{{"free"|translate}}</span><span
            class="count">{{omniChannel?.free}}</span></div>
        }
        @if (consignmentIn) {
        <div class="stock-row title"><span>{{"CONSIGNMENT IN"|translate}}</span></div>
        <div class="stock-row"><span class="title">{{"consignmentOut"|translate}}</span><span
            class="count">{{consignmentIn?.consignmentOut}}</span></div>
        <div class="stock-row"><span class="title">{{"deposit"|translate}}</span><span
            class="count">{{consignmentIn?.deposit}}</span></div>
        <!-- <div class="stock-row"><span class="title">{{"free"|translate}}</span><span
            class="count">{{consignmentIn?.free}}</span></div> -->
        }
        <!-- <div class="stock-row other separator"><span>{{"OTHER"|translate}}</span></div> -->
      </div>
    </div>
  </div>
  }
  }

  @if (inTransit.length > 0) {
  <div class="stock-row title"><span>{{"IN TRANSIT STOCK DETAILS"|translate}}</span><span class="count"></span></div>
  <div class="stock-row message">{{"Stock in transit: hourly updated"}}</div>
  <div class="stock-row title in-transit">
    <span class="title">{{"FROM"|translate}}</span>
    <span class="title">{{"SHIPPING DATE"|translate}}</span>
    <span class="title">{{"QNT"|translate}}</span>
  </div>
  <!-- @if(inTransit.length > 0){ -->
  @for (item of inTransit; track $index) {
  <!-- @if(!!item.quantity){ -->
  <div class="stock-row in-transit">
    <span class="title">{{ item.quantity ? item.from : "N/A"}}</span>
    <span class="title">{{ item.quantity ? (item.shippingDate | date:'dd/MM/yyyy') : "N/A" }}</span>
    <span class="title">{{item.quantity}}</span>
  </div>
  <!-- } -->
  <!-- } -->
  }
  }
</div>

<app-modal #modal>
  <span title>{{"E-Commerce Reservation Orders"|translate}}</span>
  <div class="list-group" body>
    @if(eCommerceReservation && eCommerceReservation.length > 0){
    @for(reservation of eCommerceReservation; track $index){
    <div class="list-group-item">
      {{reservation.orderId}}
      <!-- <div class="reservation-order">{{"Order ID"|translate}}: {{reservation.orderId}}</div>
      <div class="reservation-quantity">{{"Quantity"|translate}}: {{reservation.quantity}}</div>
      <div class="reservation-date">{{"Created At"|translate}}: {{reservation.createdAt | date:'dd/MM/yyyy HH:mm:ss'}}
      </div> -->
    </div>
    }
    }
  </div>
  <div footer class="footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      {{"Close"|translate}}
    </button>
  </div>

</app-modal>
